module.exports = __webpack_public_path__ + "static/media/blue-box-hover.22c8af36.png";